import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {fetchRateCardValueSuccess, fetchRateCardValueError, updateRateCardValueSuccess, updateRateCardValueError } from '../actions/RateCardValue';
import { getDocs, updateDoc } from 'firebase/services/rateCardValue';
import {FETCH_RATE_CARD_VALUE, UPDATE_RATE_CARD_VALUE} from 'constants/ActionTypes';

function* fetchRateCardValueRequest() {
  try {
    const fetchedRateCardValueList = yield call(getDocs);
    yield put(fetchRateCardValueSuccess(fetchedRateCardValueList));
  } catch (error) {
    console.log(error);
    yield put(fetchRateCardValueError(error));
  }
}

function* updateRateCardValueRequest({ params }) {
  try {
    const requests = params.map(param => call(updateDoc, {key: param.key, data: param}));
    const result = yield all(requests);
    yield put(updateRateCardValueSuccess(result));
  } catch (error) {
    console.log(error);
    yield put(updateRateCardValueError(error));
  }
}

export function* fetchRateCardValue() {
  yield takeEvery(FETCH_RATE_CARD_VALUE, fetchRateCardValueRequest);
}

export function* updateRateCardValue() {
  yield takeEvery(UPDATE_RATE_CARD_VALUE, updateRateCardValueRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchRateCardValue), fork(updateRateCardValue)]);
}
